'use client';

import { SparklesIcon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { Badge } from '../../components/badge';

type FeatureAnalysisCredentialBadgeProps = {
  generatedBy?: 'USER' | 'FEATURE_ANALYSIS' | null;
};

export function FeatureAnalysisCredentialBadge({
  generatedBy,
}: FeatureAnalysisCredentialBadgeProps) {
  const t = useTranslations('designSystem.applicationCredentials');

  if (generatedBy !== 'FEATURE_ANALYSIS') {
    return null;
  }

  return (
    <Badge
      variant="outline"
      size="sm"
      flexShrink={0}
      icon={<SparklesIcon size={12} />}
    >
      {t('generatedByAi')}
    </Badge>
  );
}
